import { css } from '@emotion/css'
import { breakpoint, fontSize, fontWeight, mediaQueryHelper, shorthandHelper, spacing } from '@offerzen/pinata'

const styles = {
  recommendedList: css({
    marginTop: spacing.extraLarge,
    marginBottom: spacing.extraLarge,

    [mediaQueryHelper(breakpoint.tablet, 'max-width')]: {
      padding: shorthandHelper([0, spacing.default]),
    },
  }),

  heading: css({
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    rowGap: spacing.default,
    marginBottom: spacing.medium,

    [mediaQueryHelper(breakpoint.phone, 'max-width')]: {
      flexDirection: 'column',
    },
  }),

  title: css({
    fontSize: fontSize.medium,
    fontWeight: fontWeight.semiBold,
  }),

  text: css({
    fontSize: fontSize.small,
    fontWeight: fontWeight.medium,
    margin: shorthandHelper(['auto', 0]),
  }),

  notification: css({
    marginBottom: spacing.medium,
  }),
}

export default styles
